module.exports = __webpack_public_path__ + "static/img/i12.a5eb9fe.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/i12.png
// module id = Dw7H
// module chunks = 0